import { Phone } from "lucide-react";

const CallButton = () => {
  return (
    <a
      href="tel:0646702617"
      className="fixed bottom-8 right-8 z-50 group"
      aria-label="Appeler Jacky Couverture"
    >
      {/* Effet de rayonnement animé */}
      <div className="absolute inset-0 bg-accent rounded-full animate-ping opacity-75" />
      <div className="absolute inset-0 bg-accent rounded-full blur-xl opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
      
      {/* Bouton principal */}
      <div className="relative bg-accent hover:bg-accent/90 text-accent-foreground rounded-full p-4 shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl">
        <Phone className="w-6 h-6" />
      </div>
    </a>
  );
};

export default CallButton;
